import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/imgs/cut.png'
import _imports_1 from '../../assets/imgs/gitlabLogo.png'
import _imports_2 from '../../assets/imgs/eolinkLogo.png'
import _imports_3 from '../../assets/imgs/feyshTechnologyLogo.png'


const _hoisted_1 = { class: "turntable-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "center",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "logo"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "wheel2 wheel" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "wheel3 wheel" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "wheel4 wheel" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "logo"
}
const _hoisted_8 = {
  key: 0,
  class: "logo"
}

import {ref} from 'vue';
// 用来判断是哪个logo显示

export default /*#__PURE__*/_defineComponent({
  __name: 'TurntableCard',
  props: ['message'],
  emits: ['selected'],
  setup(__props, { emit: __emit }) {

const props = __props;

// 显示eolink的Logo
const displayEolink = () => {
    if(props.message === 'SWArchitecture' || props.message === 'SWDetailedDesign' || props.message === 'coding' || props.message === 'SWUnitVerification' || props.message === 'SWIntegrationTest') {
        return true;
    } else {
        return false;
    }
}

// 显示极狐的Logo
const displayGitlab = () => {
    if(props.message === 'coding' || props.message === 'SWUnitVerification' || props.message === 'SWIntegrationTest' || props.message === 'SWQualificationTest' || props.message === 'systemIntegrationTest' || props.message === 'systemQualificationTest') {
        return true;
    } else {
        return false;
    }
}

// 显示蜚语科技的Logo
const displayfeyshTechnology = () => {
    if(props.message === 'coding' || props.message === 'SWUnitVerification') {
        return true;
    } else {
        return false;
    }
}

// 判断点击的Logo
const change = ref('');


const emit = __emit;
// 传递给父组件的信息
const selected = (str: string) => {
    change.value = str;
    if(displayGitlab() === true && str === 'gitlab' || displayEolink() === true && str === 'eolink' || displayfeyshTechnology() === true && str === 'feyshTechnology') {
        emit('selected', str);
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "wheel1 wheel",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (selected('gitlab')))
    }, [
      (displayGitlab())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              class: _normalizeClass({'clickBig': change.value === 'gitlab'}),
              src: _imports_1,
              alt: ""
            }, null, 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createElementVNode("div", {
      class: "wheel5 wheel",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (selected('eolink')))
    }, [
      (displayEolink())
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("img", {
              class: _normalizeClass({'clickBig': change.value === 'eolink'}),
              src: _imports_2,
              alt: ""
            }, null, 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "wheel6 wheel",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (selected('feyshTechnology')))
    }, [
      (displayfeyshTechnology())
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("img", {
              class: _normalizeClass({'clickBig': change.value === 'feyshTechnology'}),
              src: _imports_3,
              alt: ""
            }, null, 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})